import React from 'react';
import { MicOff, Smartphone, Repeat } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <MicOff className="w-8 h-8 text-noir-alert" data-id="element-168" />,
    title: 'El Silencio',
    description: 'Tratas de hablar de tus sentimientos y termina en pelea. El silencio en la cena es el primer síntoma de una conexión que se está apagando.'
  }, {
    icon: <Smartphone className="w-8 h-8 text-noir-alert" data-id="element-169" />,
    title: 'La Adicción',
    description: 'Intentas proponer un plan diferente y él prefiere quedarse en el celular. Las cenas románticas terminan con ambos mirando la pantalla.'
  }, {
    icon: <Repeat className="w-8 h-8 text-noir-alert" data-id="element-170" />,
    title: 'La Rutina',
    description: "Sientes que se han convertido en 'roommates' o socios logísticos en lugar de amantes. El 'modo automático' está destruyendo la relación."
  }];
  return <section className="py-20 bg-noir-bg border-b border-noir-border" data-id="element-171">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-172">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-173">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-mono text-noir-text mb-6 uppercase tracking-tight" data-id="element-174">
            ¿Recuerdas la última vez que tuvieron una conversación emocionante?
          </h2>
          <p className="text-lg text-noir-muted" data-id="element-175">
            El error es creer que la solución es "sentarse a hablar seriamente".
            Eso genera presión, defensas altas y más distancia. Intentar forzar
            la comunicación solo hace que la otra persona se cierre más.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-176">
          {problems.map((item, index) => <div key={index} className="bg-noir-card border border-noir-border p-8 rounded-sm hover:border-noir-alert/50 transition-colors duration-300 relative overflow-hidden group" data-id="element-177">
              <div className="absolute top-0 left-0 w-full h-1 bg-noir-border group-hover:bg-noir-alert transition-colors duration-300" data-id="element-178"></div>
              <div className="mb-6 bg-noir-bg border border-noir-border w-16 h-16 flex items-center justify-center rounded-sm" data-id="element-179">
                {item.icon}
              </div>
              <h3 className="text-xl font-mono font-bold text-noir-text mb-3 uppercase" data-id="element-180">
                {item.title}
              </h3>
              <p className="text-noir-muted text-sm leading-relaxed" data-id="element-181">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}